import { css } from 'styled-components';
import { mixinloadingSpinner, mixinSkeletonScreen } from '../../../../../common/css/setting/mixin';

export const FetchingStyle = css`
  ${props => mixinloadingSpinner({ size: 29, color: props.theme.news.palette.loading_gray_common })};
  margin: 12px auto;
`;

export const FetchingSkeltonScreenStyle = css`
  ${mixinSkeletonScreen({ listHeight: 104, articleCount: 10, left: 4, width: 'calc(100% - 8px)', position: 95 })}
`;
